import { render, staticRenderFns } from "./contributionPoints.vue?vue&type=template&id=a45aaa80&scoped=true"
import script from "./contributionPoints.vue?vue&type=script&lang=js"
export * from "./contributionPoints.vue?vue&type=script&lang=js"
import style0 from "./contributionPoints.vue?vue&type=style&index=0&id=a45aaa80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a45aaa80",
  null
  
)

export default component.exports